import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Input } from 'react-toolbox';
import FlexBox from 'flexbox-react';
import { error } from '../../../../utils';
import cx from 'classnames';
import formStyles from 'styles/form';

const largeInput = cx(formStyles.inputs, formStyles.largeInput);
const titleStyle = cx(formStyles.bottomTitle, formStyles.childTitle);
const DEFAULT_STATE = {
  associateName: '',
  associateEmail: '',
};

class StoreInformation extends Component {

  state = DEFAULT_STATE

  handleStoreInformation = (key, value) => {
    const state = this.state;
    state[key] = value;
    this.setState({ ...state });
    this.props.updateStoreInformation(this.state);
  }

  handleNameChange = (value) => {
    this.handleStoreInformation('associateName', value);
  }
  handleEmailChange = (value) => {
    this.handleStoreInformation('associateEmail', value);
  }

  render() {
    const { associateName, associateEmail } = this.state;
    const { errors } = this.props;
    return (
      <div className={formStyles.divider}>
        <h5 className={titleStyle}>Store Information</h5>
        <FlexBox flexWrap="wrap">
          <Input
            label="Associate's Name"
            className={largeInput}
            value={associateName}
            onChange={this.handleNameChange}
            error={error('associateName', errors)}
            required
          />
          <Input
            label="Associate's Email Address"
            className={largeInput}
            value={associateEmail}
            onChange={this.handleEmailChange}
            error={error('associateEmail', errors)}
            required
          />
        </FlexBox>
      </div>
    );
  }
}

StoreInformation.propTypes = {
  updateStoreInformation: PropTypes.func,
  errors: PropTypes.object,
};

export default StoreInformation;



// WEBPACK FOOTER //
// ./client/app/screens/refigure/form/components/storeInformation.jsx